import { motion } from "framer-motion";
import { AnimatedSection, fadeUp, CountUp } from "@/components/motion";

const metrics = [
  { value: "75", suffix: "+", label: "Years of Industry Legacy" },
  { value: "2", suffix: "+", label: "Manufacturing Units" },
  { value: "10000", suffix: "+", label: "Designs Developed" },
  { value: "500", suffix: "+", label: "B2B Clients Served" },
];

export const MetricsSection = () => (
  <section data-testid="metrics-section" className="py-24 lg:py-32 bg-[#0F172A] noise-overlay relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
      <AnimatedSection>
        <motion.div variants={fadeUp} className="mb-16">
          <p className="text-xs font-sans uppercase tracking-[0.2em] text-[#C5A059] mb-4">Our Impact</p>
          <h2 className="text-4xl md:text-5xl font-serif tracking-tight text-white">
            Built on Experience.<br />Driven by Scale.
          </h2>
        </motion.div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {metrics.map((m) => (
            <motion.div key={m.label} variants={fadeUp} className="text-left">
              <p className="text-5xl md:text-6xl font-serif text-[#C5A059] mb-3">
                <CountUp end={m.value} suffix={m.suffix} />
              </p>
              <p className="text-sm font-sans text-white/60">{m.label}</p>
            </motion.div>
          ))}
        </div>
        <motion.div variants={fadeUp} className="mt-16">
          <p className="text-base font-sans text-white/40">High Volume Monthly Production Capacity</p>
          <p className="text-sm font-sans text-white/30 mt-4">Trusted by businesses across generations.</p>
        </motion.div>
      </AnimatedSection>
    </div>
  </section>
);
